exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid{background-color:#34495e;color:#fff;width:100%;border-collapse:collapse}.gameStatus{margin:0;padding:15px;border-top-left-radius:20px;border-top-right-radius:20px;color:#fff;font-size:1.4em;font-weight:700}.gameStatus,.statusTurn{background-color:#f1c40f}.statusWin{background-color:#2ecc71}.statusDraw{background-color:#9b59b6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22e611fa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid.vue
// module id = 18
// module chunks = 0